// src/pages/RegisterRequest.jsx
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../config/api";

function RegisterRequest() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [toast, setToast] = useState(null);
  const [lastFetchTime, setLastFetchTime] = useState(new Date());
  const navigate = useNavigate();
  
  // استفاده از useRef برای ذخیره ارجاع به تایمر
  const timerRef = useRef(null);

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => {
      setToast(null);
    }, 3000);
  };

  const fetchPendingUsers = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const token = localStorage.getItem("adminToken");
      const headers = {
        "Content-Type": "application/json",
      };

      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      const response = await fetch(apiUrl("/api/auth/pending-users"), {
        method: "GET",
        headers: headers,
      });

      if (response.status === 401 || response.status === 403) {
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminUser");
        navigate("/login");
        return;
      }

      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("پاسخ سرور معتبر نیست.");
      }

      const data = await response.json();

      if (response.ok) {
        if (Array.isArray(data.users)) {
          setUsers(data.users);
          setLastFetchTime(new Date()); // آپدیت زمان آخرین دریافت
        } else {
          setUsers([]);
          setError("فرمت پاسخ سرور نامعتبر است.");
        }
      } else {
        setError(data.error || "خطا در دریافت اطلاعات");
      }

    } catch (err) {
      console.error("خطا در دریافت لیست:", err);
      setError("خطا در اتصال به سرور: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // بارگذاری اولیه
    fetchPendingUsers();

    // تنظیم تایمر برای اجرای هر 3 دقیقه (3 * 60 * 1000 = 180000 میلی‌ثانیه)
    timerRef.current = setInterval(() => {
      console.log("🔄 بارگذاری مجدد خودکار لیست انتظار...");
      fetchPendingUsers();
    }, 180000);

    // پاکسازی تایمر هنگام بستن کامپوننت
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [navigate]);

  const handleApprove = async (userId) => {
    if (!window.confirm("آیا از تایید این کاربر مطمئن هستید؟")) return;

    try {
      const token = localStorage.getItem("adminToken");
      const headers = { "Content-Type": "application/json" };
      if (token) headers["Authorization"] = `Bearer ${token}`;

      const response = await fetch(apiUrl(`/api/auth/approve/${userId}`), {
        method: "POST",
        headers: headers,
      });

      if (response.status === 401 || response.status === 403) {
        navigate("/login");
        return;
      }

      const data = await response.json();
      if (response.ok) {
        setUsers(users.filter((user) => user.id !== userId));
        showToast("✅ کاربر با موفقیت تایید شد و می‌تواند وارد سیستم شود", "success");
      } else {
        showToast(`❌ خطا: ${data.error}`, "error");
      }
    } catch (err) {
      showToast("❌ خطا در اتصال به سرور", "error");
    }
  };

  const handleReject = async (userId) => {
    if (!window.confirm("آیا از رد این کاربر مطمئن هستید؟")) return;

    try {
      const token = localStorage.getItem("adminToken");
      const headers = { "Content-Type": "application/json" };
      if (token) headers["Authorization"] = `Bearer ${token}`;

      const response = await fetch(apiUrl(`/api/auth/reject/${userId}`), {
        method: "DELETE",
        headers: headers,
      });

      if (response.status === 401 || response.status === 403) {
        navigate("/login");
        return;
      }

      const data = await response.json();
      if (response.ok) {
        setUsers(users.filter((user) => user.id !== userId));
        showToast("🗑️ کاربر با موفقیت رد شد و از دیتابیس حذف گردید", "success");
      } else {
        showToast(`❌ خطا: ${data.error}`, "error");
      }
    } catch (err) {
      showToast("❌ خطا در اتصال به سرور", "error");
    }
  };

  // فرمت کردن تاریخ برای نمایش
  const formatDate = (date) => {
    return new Intl.DateTimeFormat('fa-IR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(date);
  };

  return (
    <div>
      {/* ==================== Toast ==================== */}
      {toast && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            padding: "15px 25px",
            borderRadius: "8px",
            backgroundColor: toast.type === "success" ? "#4CAF50" : "#f44336",
            color: "white",
            fontSize: "16px",
            zIndex: 9999,
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            direction: "rtl",
            animation: "slideIn 0.3s ease",
          }}
        >
          {toast.message}
        </div>
      )}
      
      {/* نمایش زمان آخرین بروزرسانی */}
      <div style={{ marginBottom: "10px", fontSize: "12px", color: "#666", textAlign: "right" }}>
        آخرین بروزرسانی: {formatDate(lastFetchTime)} (بروزرسانی خودکار هر ۳ دقیقه)
      </div>

      <div className="SelectedHeader">
        کاربران جدید الورود که درخواست ورود و ثبت نام در سامانه شما دارند اینجاست .
        شما می توانید با توجه به نام کاربر و شناسه های موجود ورود کاربر را تایید و یا رد کنید .
      </div>
      <div className="NewUsers mt-3">
        <p>نام</p>
        <p>نام خانوادگی</p>
        <p>کد ملی</p>
        <p>شماره تماس</p>
        <p>نام زرگری</p>
        <p>آدرس مغازه</p>
        <p>اعمال</p>
      </div>
      {loading ? (
        <p style={{ textAlign: "center", marginTop: "20px" }}>در حال بارگذاری...</p>
      ) : error ? (
        <p style={{ textAlign: "center", marginTop: "20px", color: "red" }}>{error}</p>
      ) : users.length === 0 ? (
        <p style={{ textAlign: "center", marginTop: "20px" }}>هیچ کاربری در انتظار تایید نیست.</p>
      ) : (
        users.map((user) => (
          <div key={user.id} className="NewUserRow">
            <p>{user.firstName}</p>
            <p>{user.lastName}</p>
            <p>{user.nationalCode}</p>
            <p>{user.phone}</p>
            <p>{user.goldsmithName}</p>
            <p>{user.shopAddress}</p>
            <p className="gap-10">
              <button className="AgreeUser" onClick={() => handleApprove(user.id)}>تایید</button>
              <button className="EgnorUser" onClick={() => handleReject(user.id)}>رد</button>
            </p>
          </div>
        ))
      )}
    </div>
  );
}
export default RegisterRequest;
